import { useTranslation } from "react-i18next";
import SideBarItemList from "../../../components/sidebar/SideBarItemList";
import SolarCartLarge4Outline from "../../../components/icons/SolarCartLarge4Outline";


const MarketSideBarMenu = () =>{
    const { t } = useTranslation(['Market', 'common']); 
    return (<>
        <SideBarItemList
            title={t('sideTitle')}
            icon={(<SolarCartLarge4Outline/>)}
            itemsList={[ 
                {label:t('sideItemCategory'), to:'/market/categories', startsWith:'/market/categor'},
                {label:t('sideItemProduct'), to:'/market/products', startsWith:'/market/product'}, 
                {label:t('sideItemOrders'), to:'/market/orders'},
                {label:t('sideItemReviews'), to:'/market/reviews', startsWith:'/market/reviews'}
            ]}/>
    </>); 
}

export default MarketSideBarMenu;   